import React, { useLayoutEffect } from "react";
import LicensesBox from "../components/StudentsComponents/LicensesBox";
import { useNavigate } from "react-router-dom";
import TextWithBackButton from "../components/TextWithBackButton";
import Header from "../components/Header/Header";
import useOrganisation from "../store/Querys/useOrganisation";
import useSingleOrganization from "../store/Querys/useSingleOrganization";

const Licenses = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    metaThemeColor && metaThemeColor.setAttribute("content", "#F5F5FC");
  }, []);

  const { data: organizationsData } = useOrganisation();
  const orgId = organizationsData?.organizations?.[0]?.id || "";

  const { data: singleOrganizationData } = useSingleOrganization(orgId);

  return (
    <div className="h-svh flex flex-col bg-[#F5F5FC] pb-80">
      <Header backgroundColor="[#F5F5FC]" />
      <div className="px-12">
        <TextWithBackButton
          text="Licenses"
          subText="Current amount of licenses."
          backBtnClick={() => navigate("/students")}
        />
      </div>
      <LicensesBox
        onInviteBtnClick={() => navigate("/students/invite")}
        singleOrganizationData={singleOrganizationData}
      />
    </div>
  );
};

export default Licenses;
